export enum Scarcity {
	EXPIRED = 'Expired',
	NO_SCARCITY = 'NoScarcity',
	TODAY = 'Today',
	TOMORROW = 'Tomorrow',
	TWO_TO_FIFTEEN_DAYS = '2to15Days',
	NO_APPLICABLE = 'NoApplicable'
}
